import type { Router } from '@tanstack/react-router';

import { initI18n } from '#core/i18n/i18n.ts';
import { init } from '#core/main.tsx';

import { config } from '#config.ts';
import { routeTree } from '#routeTree.gen.ts';

import { AppProvider } from '#contexts/AppProvider.tsx';
import { resources } from '#i18n/resources.ts';

initI18n(resources);
init(routeTree, config, AppProvider);

declare module '@tanstack/react-router' {
  interface Register {
    // @ts-expect-error - App router extends core router with merged routes
    router: Router<typeof routeTree>;
  }
}

type ConfigType = typeof config;

declare module '#core/schema/ProjectConfigSchema.ts' {
  interface ProjectConfigOverrides extends ConfigType {}
}
